import { Icon } from "../../../../../../components";
import Typography from "../../../../../../components/typography/Typography";
import styles from "./llm-summary.module.scss";

const LLMSummaryWarning = () => (
  <div className={"flex flex-gap-2 m-top-2 m-bottom-2"}>
    <Icon name="info-circle" />
    <Typography variant="body1" className={styles.llm_text_gray}>
      This content was generated with AI. Review for accuracy before relying on
      it. Summary is generated based on a subset of most relevant data.
    </Typography>
  </div>
);

export default LLMSummaryWarning;
